<template>
    <div style="min-height: 100vh;">
        <div class="floating_btn">
            <div class="floatinig_btn_inner_div">
                <div class="grouped_icons text-center">
                    <img src="@/assets/img/call.png" width="80%" />
                </div>
            </div>
        </div>
        <div class="row login__wrapper no_margin" style="min-height: 100vh;">
            <div class="col-md-12 col-lg-6 no_padding">
                <div class="left_wrapper">
                    <h3 class="welcome_header" style="font-size:35px; margin-top:50px">Reset Password</h3>
                  
                    <!-- <p class="text-center mt-4">DPR compentency Administrative System</p> -->
                    <section class="login__section__Wrapper mt-5">
                        <form>  <!-- @submit="validateForm($event)"> -->
                            <div class="login___section__container">
                                <div class="login__input" ref="email_input_div">
                                    <span>Username</span>
                                    <div class="input___group">
                                        <img src="@/assets/img/username-icon.svg" class="ml-3" width="20px" />
                                        <input type="email" placeholder="Email" v-model="email" class="ml-3" @blur="captureFormEvents($event)" />
                                    </div>
                                </div>
                                <div ref="email_error_message" class="error-validation text-center"></div>
                                <div class="login__input mt-4" ref="password_input_div">
                                    <span>New Password</span>
                                    <div class="input___group">
                                        <img src="@/assets/img/password-icon.svg" class="ml-3" width="20px" />
                                        <input type="password" placeholder="Password" class="ml-3"
                                               ref="pass__input" @blur="captureFormEvents($event)" v-model="password" />
                                        <!-- <div>
                                            <i class="fa fa-eye-slash" aria-hidden="true" @click="toggleShowPassword" v-if="showPassword"></i>
                                            <i class="fa fa-eye" aria-hidden="true" @click="toggleShowPassword" v-if="!showPassword"></i>
                                        </div> -->
                                    </div>
                                </div>
                                <div ref="password_error_message" class="error-validation text-center"></div>
                                <div class="login__input mt-4" ref="conf_password_input_div">
                                    <span>Confirm New Password</span>
                                    <div class="input___group">
                                        <img src="@/assets/img/password-icon.svg" class="ml-3" width="20px" />
                                        <input type="password" placeholder="Confirm password" class="ml-3"
                                               ref="pass__input" @blur="captureFormEvents($event)" v-model="confirmPassword" />
                                        <!-- <div>
                                            <i class="fa fa-eye-slash" aria-hidden="true" @click="toggleShowPassword" v-if="showPassword"></i>
                                            <i class="fa fa-eye" aria-hidden="true" @click="toggleShowPassword" v-if="!showPassword"></i>
                                        </div> -->
                                    </div>
                                </div>
                                <div ref="confirm_password_error_message" class="error-validation text-center"></div>
                                <!-- <div class="login__input" ref="email_input_div">
                                    <span>Password</span>
                                    <div class="input___group">
                                        <img src="@/assets/img/password-icon.svg" class="ml-3" width="20px" />
                                        <input type="password" placeholder="Password" v-model="password" class="ml-3" @blur="captureFormEvents($event)" />
                                    </div>
                                </div> -->
                                <!-- <div class="login__input" ref="email_input_div">
                                    <span>Confirm Password</span>
                                    <div class="input___group">
                                        <img src="@/assets/img/password-icon.svg" class="ml-3" width="20px" />
                                        <input type="email" placeholder="Confirm password" v-model="confirmPassword" class="ml-3" @blur="captureFormEvents($event)" />
                                    </div>
                                </div>
                                <div ref="email_error_message" class="error-validation text-center"></div> -->
                              
                            </div>
                            <div class="text-center mt-5">
                                <button type="submit" class="login__btn"
                                        @click="resetPassword($event)"
                                        :disabled="isButtonDisabled ? true : null"
                                        :style="[
                                        isButtonDisabled
                                            ? { cursor: 'not-allowed' }
                                            : { cursor: 'pointer' }
                                        ]">Reset Password
                                        <span class="" v-if="showLoader">
                                            <img src="@/assets/img/git_loader.gif"  width="25px"/>
                                        </span>
                                </button>
                            </div>
                        </form>
                      
                        <div style="margin: 0 auto: width: 95%">
                            <img src="@/assets/img/Group 139.png" />
                        </div>
                    </section>
                </div>
            </div>
            <div class="col-md-12 col-lg-6 no_padding">
                <div class="right_wrapper" :style="{
                    backgroundImage: `linear-gradient(rgb(9, 140, 40 , 0.92), rgb(9, 140, 40, 0.92)), url(${backgroundUrl})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: '79% 50%' }">
                    <section class="top__bar">
                        <div class="top__bar__inner_div">
                            <ul>
                                <li class="mr-4">Competency Profile</li>
                                <li class="mr-4">Assessment &amp; Benchmarking</li>
                                <li class="mr-4">LMS</li>
                                <li>Report Analytics</li>
                            </ul>
                        </div>
                    </section>
                    <section>
                        <div class="learn__more_welcome_header text-center">
                           Change Password
                        </div>
                        <!-- <div class="mt-3 text-center">
                            <img src="@/assets/img/favorites (1).svg" class="mr-3" />
                        </div> -->
                        <h4 class=" text-center mt-4 dcas__para_text mt-5" style="line-height: 1.5">
                          Enter your details in the fields <br> in the left
                         section to reset your password
                        </h4>
                        <!-- <div class="mt-5 text-center">
                            <button type="submit"
                                    class="btn btn-primary sign_up_btn">
                               How it works
                            </button>
                        </div> -->
                    </section>

                    <section class="footer_bar">
                        <p>Copyright &copy; {{year}}
                        </p>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import backgroundUrl from "@/assets/img/f6c324105a64e036f9e668224c23e501.jpg";
    import configObject from "@/config";


export default {
    data() {
        return {
            year: new Date().getFullYear(),
            backgroundUrl,
            isButtonDisabled: false,
            showLoader: false,
            showPassword: false,
            formIsValid: false,
            email: '',
            password: '',
            confirmPassword: '',
            code: '',
            userInfo: localStorage.getItem("dcasUserDetails")
            ? JSON.parse(localStorage.getItem("dcasUserDetails"))
            : null,
        }
    },
    created() {
        console.log('Welcome to login');
        this.code = this.$route.query.code;
        this.email = this.$route.query.email;

        let userInfo = JSON.parse(localStorage.getItem("dcasUserDetails"));
        if (userInfo !== null && userInfo !== "null") {
            console.log('Roles => ' + userInfo.roles);
             if(userInfo.roles.includes('SuperAdmin')){
                this.$router.push({name: "company"});
            }
            else if(userInfo.roles.includes('Admin')){
                this.$router.push({name: "branch"});
            }
            else if(userInfo.roles.includes('Staff')){
                this.$router.push({name: "employee_dashboard"});
            }
        }
       
    },
    methods: {
        toggleShowPassword() {
            if(this.$refs.pass__input.type === 'password'){
                this.$refs.pass__input.type = 'text'
                this.showPassword = true;
            }else {
                this.$refs.pass__input.type = 'password';
                this.showPassword = false;
            }
        },
        validatePasword(password) {
            let validate = /^(?=.*[\d])(?=.*[!@#$%^&*])[\w!@#$%^&*]{6,}$/;
            if (password.length > 6) {
                return true;
            }
            return validate.test(password);
        },
        validEmail(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        },
        resetPassword($event) {
            $event.preventDefault();
            if(this.email && this.password && this.confirmPassword)
            {
                let dataToSend = {
                    email: this.email,
                    code: this.code,
                    password: this.password
                };

                this.showLoader = true;
                this.isButtonDisabled = true;
                this.axios.post(`${configObject.apiBaseUrl}/Account/ResetPassword`, dataToSend, configObject.authConfig)
                .then(response => {
                    console.log(response.data);
                    this.showLoader = false;
                    this.isButtonDisabled = false;
                    this.$toast.open({
                        type: "success",
                        message: "Password Reset Successfully",
                        duration: 4000
                    });
                    this.$router.push({
                        name: "login"
                    });
                })
                .catch((error) => {
                    console.log(error);
                    this.$toasted.show("Request Failed", {
                        theme: "bubble",
                        position: "top-center",
                        duration: 4000
                    });
                    this.isButtonDisabled = false;
                    this.showLoader = false;
                });
            }
            else{
                this.$toasted.show("Please complete all fields", {
                    theme: "bubble",
                    position: "top-center",
                    duration: 4000
                });
            }
        },
        // validateForm($event) {
        //     $event.preventDefault();
        //     if (!this.email || !this.password) {
        //         this.$toasted.show("Username & Password fields are required", {
        //             theme: "bubble",
        //             position: "top-center",
        //             duration: 3000
        //         });
        //         this.formIsValid = false;
        //     }
        //     if (this.formIsValid) {
        //         this.login();
        //     }
        // },
        captureFormEvents($event) {
            if ($event.target.placeholder.toLowerCase() === "email") {
                if ($event.target.value === "") {
                    this.$refs.email_error_message.style.display = "block";
                    this.$refs.email_error_message.innerHTML =
                        "Email field cannot be blank";
                    this.$refs.email_input_div.style.border = "1px solid red";
                    this.$refs.email_error_message.style.color = "red";
                    this.formIsValid = false;
                } else {
                    if (this.validEmail($event.target.value)) {
                        this.$refs.email_error_message.style.display = "none";
                        this.$refs.email_error_message.innerHTML = "";
                        this.$refs.email_input_div.style.border =
                            "1px solid rgb(9, 140, 40)";
                        this.formIsValid = true;
                    } else {
                        this.$refs.email_error_message.style.color = "red";
                        this.$refs.email_error_message.innerHTML = "Invalid Email format";
                        this.$refs.email_input_div.style.border = "1px solid red";
                        this.formIsValid = false;
                    }
                }
            }
            if ($event.target.placeholder.toLowerCase() === "password") {
                if ($event.target.value === "") {
                    this.$refs.password_error_message.style.display = "block";
                    this.$refs.password_error_message.innerHTML =
                        "Password field cannot be blank";
                    this.$refs.password_input_div.style.border = "1px solid red";
                    this.$refs.password_error_message.style.color = "red";
                    this.formIsValid = false;
                } else {
                    this.$refs.password_error_message.style.display = "none";
                    this.$refs.password_input_div.style.border = "1px solid rgb(9, 140, 40)";
                    this.formIsValid = true;
                }
            }
            if ($event.target.placeholder.toLowerCase() === "confirm password") {
                if ($event.target.value === "") {
                    
                    this.$refs.confirm_password_error_message.style.display = "block";
                    this.$refs.confirm_password_error_message.innerHTML =
                        "Confirm Password field cannot be blank";
                    this.$refs.conf_password_input_div.style.border = "1px solid rgb(9, 140, 40)";
                    this.$refs.confirm_password_error_message.style.color = "red";
                    this.formIsValid = false;
                } 
                else if(this.password !== this.confirmPassword){
                    this.$refs.confirm_password_error_message.style.display = "block";
                    this.$refs.confirm_password_error_message.innerHTML =
                        "Passwords and Confirm Password does not match";
                    this.$refs.conf_password_input_div.style.border = "1px solid rgb(9, 140, 40)";
                }
                else  {
                    this.$refs.confirm_password_error_message.style.display = "none";
                    this.$refs.conf_password_input_div.style.border = "1px solid rgb(9, 140, 40)";
                    this.formIsValid = true;
                }
            }
        }
    }
    
}
</script>
<style>
</style>